/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateUserTaskRequest
 */
export interface CreateUserTaskRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateUserTaskRequest
     */
    assigneeUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateUserTaskRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserTaskRequest
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUserTaskRequest
     */
    dueAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserTaskRequest
     */
    sourceModule?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserTaskRequest
     */
    sourceReference?: string | null;
}

/**
 * Check if a given object implements the CreateUserTaskRequest interface.
 */
export function instanceOfCreateUserTaskRequest(value: object): value is CreateUserTaskRequest {
    if (!('assigneeUserId' in value) || value['assigneeUserId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function CreateUserTaskRequestFromJSON(json: any): CreateUserTaskRequest {
    return CreateUserTaskRequestFromJSONTyped(json, false);
}

export function CreateUserTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assigneeUserId': ApiUserTasksGetPageParameterFromJSON(json['assigneeUserId']),
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'sourceModule': json['sourceModule'] == null ? undefined : json['sourceModule'],
        'sourceReference': json['sourceReference'] == null ? undefined : json['sourceReference'],
    };
}

export function CreateUserTaskRequestToJSON(json: any): CreateUserTaskRequest {
    return CreateUserTaskRequestToJSONTyped(json, false);
}

export function CreateUserTaskRequestToJSONTyped(value?: CreateUserTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assigneeUserId': ApiUserTasksGetPageParameterToJSON(value['assigneeUserId']),
        'title': value['title'],
        'description': value['description'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'sourceModule': value['sourceModule'],
        'sourceReference': value['sourceReference'],
    };
}

